module.exports = __webpack_public_path__ + "static/media/4-8.772f2369.mp3";